import { USStatesAndTerritories } from '@commenda/types';

export interface INexusService {
  getNexus(corporationId: number): Promise<GetNexusReturnType[]>;
}

type TNexusCorporationInfo = {
  id: number;
  name: string;
};

export interface GetNexusReturnType {
  state: USStatesAndTerritories;
  nexusRule: NexusRule | null;
  calculation: NexusCalculationsByState | null;
  // Will be returned for passed-in corporation ids only:
  corporations?: TNexusCorporationInfo[];
}

export interface NexusCalculationsByState {
  exposurePercentage: number; // 0-100% of how close the corporation is to nexus threshold

  salesExposurePercentage: number; // 0-100%
  transactionExposurePercentage: number; // 0-100%

  totalSales: number;
  totalTransactions: number;

  isNexusEstablished: boolean;
  // Whether you have registered in a particular state for nexus or not
  hasNonRegisteredCorporations?: boolean;

  // Set if physical nexus is triggered.
  // May be empty if the location is not named in HR software:
  triggeringPhysicalNexusLocationNames?: string[];
  triggeringPhysicalNexusWFHEmployeeNames?: string[];
}

// See https://www.avalara.com/us/en/learn/guides/state-by-state-guide-economic-nexus-laws.html for details
export enum NexusThreshold {
  SalesOnly = 'SalesOnly',
  SalesOrTransactions = 'SalesOrTransactions',
  SalesAndTransactions = 'SalesAndTransactions',
}

export enum NexusEvaluationPeriodLegacy {
  PreviousCalendarYear = 'PrevCalendarYear',
  PreviousOrCurrentCalendarYear = 'PrevOrCurrentCalendarYear',
  // TODO: handle these individually
  Other = 'Other',
}

export type NexusRule = {
  // The state this rule is linked to
  state: USStatesAndTerritories; //
  // USD: number of sales
  salesThreshold: number | null;
  // Count of transactions within a state that require
  transactionThreshold: number | null;
  thresholdType: NexusThreshold;
  evaluationPeriodType: NexusEvaluationPeriodLegacy;
};
